import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';


export default function RouteBasicInfoComponent({ handleInnerFormChange, selectedRoute, regions }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Route Number"
              name="MobilityRouteNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityRouteNumber',

                )
              }}
              type="number"
              value={selectedRoute?.MobilityRouteNumber}
            />
            <InputContainer

              label="Route Name"
              name="MobilityRouteName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityRouteName',

                )
              }}
              type="text"
              value={selectedRoute?.MobilityRouteName}
            />
            <InputContainer
              label="Region "
              labelField="MobilityRegionName"
              list={regions}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityRegionId',
                  selectedRoute
                );
              }}
              optionName='Choose Region'
              type="select"
              value={selectedRoute?.MobilityRegionId}
              valueField="Id"
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}